import { hideModal } from '../../state/modal/modalActions';
import {
  Dialog,
  DialogContent,
  DialogPortal,
  DialogOverlay,
  DialogTitle,
  DialogDescription,
} from '@radix-ui/react-dialog';
import styles from './Modal.module.scss';
import classNames from 'classnames/bind';
import Button from '../../components/Button';

const cx = classNames.bind(styles);

interface ModalProps {
  title?: string;
  description?: string;
  buttonText?: string;
  isOpen?: boolean;
  onConfirm?: () => void;
  hideModal: typeof hideModal;
}

const Modal = (props: ModalProps) => {
  const { isOpen, title, description, buttonText, onConfirm, hideModal } =
    props;

  const handleClose = () => {
    hideModal();
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
    handleClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogPortal>
        <DialogOverlay className={cx('modal__overlay')} />
        <DialogContent
          className={cx('modal__content')}
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
        >
          <div className={cx('modal__header')}>
            <DialogTitle className={cx('modal__title')}>{title}</DialogTitle>
            {description && (
              <DialogDescription className={cx('modal__description')}>
                {description}
              </DialogDescription>
            )}
          </div>

          <div className={cx('modal__footer')}>
            <Button onClick={handleConfirm}>{buttonText || 'Confirm'}</Button>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default Modal;
